import React from 'react';
import { array } from 'prop-types';
import styled from 'styled-components';
import Avatar from '~/views/common/Avatar';

const Container = styled.div`
    display: flex;
    padding: 10px 0px;
    flex-direction: column;
    flex-wrap: wrap;
`;

const WrapperItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 600px;
    padding: 10px;
    border: 1px solid rgba(222, 222, 222, 1);
    margin-bottom: 5px;
    border-radius: 4px;
    align-items: center;
`;

const WrapperName = styled.div`
    display: flex;
    align-items: center;
`;

const Name = styled.span`
    font-size: 15px;
`;

const AffiliateList = ({
    confirmedAffiliates,
}) => (
    <Container>
        {
            confirmedAffiliates.map(aff => (
                <WrapperItem key={aff.id}>
                    <WrapperName>
                        <Avatar src={aff.logo} />
                        <Name>{ aff.name }</Name>
                    </WrapperName>
                </WrapperItem>
            ))
        }
    </Container>
);


AffiliateList.propTypes = {
    confirmedAffiliates: array,
};

export default AffiliateList;
